import React from 'react';
import { styled } from '@compiled/react';
import { fontSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	duration: string;
};

export const DurationViewFieldComponent = ({ duration }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<ReadViewContainerwithFF>
			{duration || formatMessage(messages.noTarget)}
		</ReadViewContainerwithFF>
	);
};

export const DurationViewField = DurationViewFieldComponent;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ReadViewContainerwithFF = styled.td({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontSize: `${fontSize}px`,
	lineHeight: 1.25,
	wordBreak: 'break-word',
});
